import { toDecimal } from "./to-decimal"

export const calcPercent = (num: number, perc: number) => {
    return toDecimal(num * (perc / 100), 6)
}